import * as qs from "query-string";
import { useHistory } from "react-router-dom";
import { WPPost } from "../../../constants/types";
import { ListingAcf } from "../../../constants/types/acf";
import { useHashUpdater } from "../../../utils/hooks";

// URL hash 'parameter' key used to persist listing modal between page refreshes
const LISTING_URL_PARAM_KEY = "service";

// Allows us to keep rendering a listing while it is being animated away (even
// though the window hash doesn't exist anymore)
let lastListingHash = "";

export const listingDataCache: Record<string, WPPost<ListingAcf>> = {};

export const useListingModal = () => {
    const updateHash = useHashUpdater();
    const history = useHistory();
    const hash = qs.parse(history.location.hash);

    const openListing = (listing: WPPost<ListingAcf>) => {
        listingDataCache[listing.slug] = listing;
        updateHash({ [LISTING_URL_PARAM_KEY]: listing.slug });
    };

    const closeListing = () => {
        updateHash({ [LISTING_URL_PARAM_KEY]: undefined });
    };

    if (hash[LISTING_URL_PARAM_KEY]) {
        lastListingHash = hash[LISTING_URL_PARAM_KEY] as string;
    }

    const listingItemSlug = (hash[LISTING_URL_PARAM_KEY] as string) ?? lastListingHash;
    const isOpen = Boolean(hash[LISTING_URL_PARAM_KEY]);

    return { openListing, closeListing, listingItemSlug, isOpen };
};
